import { Route } from 'vue-router';

export const AccountSidebarItem = {
    DividerSection1: 'DividerSection1',
    DividerSection2: 'DividerSection2',
    BonusAndCommsNotifications: 'BonusAndCommsNotifications',
    ChatPlaceholder: 'ChatPlaceholder',
    PromotionHub: 'PromotionHub',
    MySocial: 'MySocial',
    LoyaltySupercoins: 'LoyaltySupercoins',
    ReferAFriend: 'ReferAFriend',
    Deposit: 'Deposit',
    Withdrawal: 'Withdrawal',
    History: 'History',
    Profile: 'Profile',
    DocumentUploadV1: 'DocumentUploadV1',
    DocumentUploadV2: 'DocumentUploadV2',
    IdentityVerification: 'IdentityVerification',
    ValidatePhone: 'ValidatePhone',
    ResponsibleGaming: 'ResponsibleGaming',
    Settings: 'Settings',
    HelpAndSupport: 'HelpAndSupport',
} as const;
export type AccountSidebarItem = typeof AccountSidebarItem[keyof typeof AccountSidebarItem];

type SidebarRouteItem = {
    key: AccountSidebarItem;
    label: string;
    iconName: string;
    to: string;
    onClick?: (route: Route) => void;
    badge?: string | undefined;
    isEnabled: boolean;
    isActive?: boolean;
    isExactRoute?: boolean;
    isDivider?: false;
};

type SidebarDivider = {
    isDivider: true;
    key: AccountSidebarItem;
};

export type SidebarItem = SidebarDivider | SidebarRouteItem;
